import { render, staticRenderFns } from "./menuGuiaComponent.vue?vue&type=template&id=7b8c0bfd"
import script from "./menuGuiaComponent.vue?vue&type=script&lang=js"
export * from "./menuGuiaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports